import { createContext } from 'react';

export interface SharedLinkInfo {
  assetId?: string;
  collectionId?: string;
  downloadable?: boolean;
}

export interface SharedLinkContextValue {
  linkInfo: SharedLinkInfo;
  linkId: string;
}

export const SharedLinkContext = createContext<SharedLinkContextValue>({
  linkInfo: {},
  linkId: '',
});
